import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "external",
  "use": "external-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"external\"><g fill-rule=\"evenodd\"><path d=\"M12.5 3.5V11h-1V4.5H5v-1z\" /><path d=\"M11.646 3.646l.708.708-7.756 7.755-.707-.707z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol